import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "qr"
};
import { useRouter } from "vue-router";
import { showDialog } from "vant";
import QrScanner from '@/components/QrScanner/index.vue';
import Bus from "@/utils/eventBus";
export default {
  __name: 'qr',
  setup(__props) {
    const qrcodeError = err => {
      showDialog({
        message: '摄像头授权失败，请检测当前浏览器是否有摄像头权限。'
      });
    };
    const router = useRouter();
    const qrcodeSucess = data => {
      Bus.$emit("qrChange", data);
      router.go(-1);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(QrScanner, {
        onSuccess: qrcodeSucess,
        onError: qrcodeError
      })]);
    };
  }
};